import React, { FC, useEffect, useState } from 'react';
import { connectSearchBox } from 'react-instantsearch-dom';
import classNames from 'classnames';

import { isBrowser } from 'utils/browser';
import { TAB } from 'utils/constants';

import Search from '../../icons/search.svg';
import { CustomSearchBoxProps } from './models';

import './CustomSearchBox.scss';

const SearchBox = ({
  currentRefinement,
  refine,
  searchBtnText,
  searchPlaceholder,
  isCleared,
  handleSearchChange,
}) => {
  const [isFocused, setIsFocused] = useState<boolean>(false);
  const [searchTerm, setSearchTerm] = useState<string>();

  useEffect(() => {
    if (isCleared) {
      refine('');
    }
  }, [isCleared]);

  useEffect(() => {
    let pushGtmEvent: NodeJS.Timeout;

    if (isBrowser() && searchTerm) {
      pushGtmEvent = setTimeout(() => {
        (window as any).dataLayer.push({
          event: 'Search event',
          term: searchTerm,
          url: window.location.href,
        });
      }, 2000);
    }

    return () => clearTimeout(pushGtmEvent);
  }, [searchTerm]);

  const handleFocus = (e) => {
    if (e.key === TAB) {
      setIsFocused(true);
    }
  };

  const handleBlur = () => {
    setIsFocused(false);
  };

  return (
    <div className={classNames('filters__search', { 'filters__search--focused': isFocused })}>
      <label htmlFor="search-filter" className="sr-only">
        search-label
      </label>
      <input
        type="search"
        value={currentRefinement}
        placeholder={searchPlaceholder}
        onChange={(event) => {
          refine(event.currentTarget.value);
          handleSearchChange();
          setSearchTerm(event.currentTarget.value);
        }}
        onKeyUp={handleFocus}
        onBlur={handleBlur}
        className="filters__search-input text-input"
        id="search-filter"
      />
      <div className="filters__search-btn">
        <span className="filters__search-text">{searchBtnText}</span>
        <span className="filters__search-icon" aria-hidden="true">
          <Search className="filters__search-pic" alt={searchBtnText} />
        </span>
      </div>
    </div>
  );
};

const CustomSearchBox: FC<CustomSearchBoxProps> = connectSearchBox(SearchBox);

export default CustomSearchBox;
